import React from "react";

import ChangeSubscriptionStatus from "../changeSubscriptionStatus/changeSubscriptionStatus";

const ClientIdRow = (props) => {
  const {
    handleModalClose,
    onClientIdSelected,
    onAppSelectHandler,
    selectedAppForSubscribe,
    loading,
    application: { title, clientIdDev, order, uuid, organizationName },
  } = props;

  const handleSelection = (id) => {
    if (!id) return;
    onClientIdSelected(id);
    handleModalClose();
  };

  const subscribingLoader = loading && uuid === selectedAppForSubscribe;

  const subscribed = order === 0;

  return (
    <li className="row line">
      <div className="cell forum">{title}</div>
      <div className="cell organization">{organizationName || "Unknown"}</div>
      <div
        onClick={(event) => {
          event.preventDefault();
          subscribed && clientIdDev && handleSelection(clientIdDev);
        }}
        className={`cell ${
          subscribed && clientIdDev
            ? "selection-cell"
            : "selection-cell-disabled"
        }`}
      >
        <span>
          {subscribed
            ? clientIdDev || "Client ID not available"
            : "Subscribe to enable a client id"}
        </span>
      </div>
      <div className="cell tr_white posts">
        <ChangeSubscriptionStatus
          button
          withIcon
          circleIcon
          subscribed={subscribed}
          appId={uuid}
          passiveVerbs
          loading={subscribingLoader}
          selectedApp={selectedAppForSubscribe}
          changeSubscriptionStatus={({ type }) => {
            // Call the app select handler which handles subscription logic
            if (onAppSelectHandler) {
              onAppSelectHandler(type, uuid);
            }
          }}
        />
      </div>
    </li>
  );
};

export default ClientIdRow;
